/*
 * mv-cart.js — Jewellery by JF AJAX add-to-cart (Wave 1 shared foundation)
 * ---------------------------------------------------------------
 * Self-initializing. No inline init needed by consumers.
 * Intercepts:
 *   (a) submit on any  form[action$="/cart/add"]   (PDP product form)
 *   (b) click  on any  [data-mv-cart-add][data-variant-id]  (product cards)
 * On success: refresh /cart.js, update every [data-mv-cart-count],
 *   dispatch  mv:cart:added, show toast, transient "Added" button state.
 * On error: surface message, never reload.
 */
(function () {
  'use strict';
  if (window.MVCart) return; // idempotent

  var TOAST_TIMEOUT = 4000;
  var ADDED_TIMEOUT = 1800;
  var toastTimer = null;

  // Icon-only feedback for the compact card quick-add button (matches the
  // cart+ glyph in snippets/mv-product-card.liquid — no text, just a mark).
  var ADDED_ICON = '<svg class="mv-add-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var FAILED_ICON = '<svg class="mv-add-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7 7l10 10M17 7L7 17"/></svg>';

  // Localized UI strings come from [data-mv-toast] data-str-* attributes
  // (emitted via Liquid `| t` in snippets/mv-cart-toast.liquid). English
  // fallbacks keep the script working if the toast is absent or the key
  // is missing. key is the camelCase suffix, e.g. str('Added', '…').
  function str(key, fallback) {
    var toast = document.querySelector('[data-mv-toast]');
    var v = toast && toast.dataset ? toast.dataset['str' + key] : null;
    return v || fallback;
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function updateCartCount(count) {
    qsa('[data-mv-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count !== 'undefined') updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function () { return null; });
  }

  function showToast(item) {
    var toast = document.querySelector('[data-mv-toast]');
    if (!toast) return;
    var img = toast.querySelector('[data-mv-toast-img]');
    var title = toast.querySelector('[data-mv-toast-title]');
    if (title) title.textContent = (item && (item.product_title || item.title)) || str('Added', 'Added to bag');
    if (img) {
      var src = item && (item.image || (item.featured_image && item.featured_image.url));
      if (src) {
        img.src = src;
        img.style.display = '';
      } else {
        img.style.display = 'none';
      }
    }
    toast.classList.add('is-visible');
    toast.removeAttribute('hidden');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_TIMEOUT);
  }

  function hideToast() {
    var toast = document.querySelector('[data-mv-toast]');
    if (!toast) return;
    toast.classList.remove('is-visible');
    setTimeout(function () {
      if (!toast.classList.contains('is-visible')) toast.setAttribute('hidden', '');
    }, 300);
  }

  function flashButton(btn, ok, msg) {
    if (!btn) return;
    if (btn.dataset.mvBusy === '1') return;
    var original = btn.getAttribute('data-mv-original') || btn.innerHTML;
    btn.setAttribute('data-mv-original', original);
    if (!btn.hasAttribute('data-mv-original-label') && btn.hasAttribute('aria-label')) {
      btn.setAttribute('data-mv-original-label', btn.getAttribute('aria-label'));
    }
    btn.dataset.mvBusy = '1';
    btn.innerHTML = ok ? ADDED_ICON : FAILED_ICON;
    btn.setAttribute('aria-label', ok ? str('Success', 'Added') : (msg || str('Unavailable', 'Unavailable')));
    setTimeout(function () {
      btn.innerHTML = btn.getAttribute('data-mv-original');
      if (btn.hasAttribute('data-mv-original-label')) {
        btn.setAttribute('aria-label', btn.getAttribute('data-mv-original-label'));
      }
      btn.dataset.mvBusy = '0';
    }, ADDED_TIMEOUT);
  }

  function handleSuccess(item, btn) {
    refreshCart().then(function (cart) {
      document.dispatchEvent(new CustomEvent('mv:cart:added', { detail: { item: item, cart: cart } }));
    });
    showToast(item);
    flashButton(btn, true);
  }

  function handleError(btn, message) {
    flashButton(btn, false, message);
    var toast = document.querySelector('[data-mv-toast]');
    if (toast) {
      var title = toast.querySelector('[data-mv-toast-title]');
      if (title) title.textContent = message || str('Error', 'Could not add to bag');
      var img = toast.querySelector('[data-mv-toast-img]');
      if (img) img.style.display = 'none';
      toast.classList.add('is-visible');
      toast.removeAttribute('hidden');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(hideToast, TOAST_TIMEOUT);
    }
  }

  function postJSON(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        return { ok: r.ok, data: data };
      });
    });
  }

  function postForm(form) {
    var fd = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    }).then(function (r) {
      return r.json().then(function (data) {
        return { ok: r.ok, data: data };
      });
    });
  }

  function addById(id, quantity, btn) {
    var qty = parseInt(quantity, 10);
    if (!qty || qty < 1) qty = 1;
    return postJSON({ items: [{ id: id, quantity: qty }] })
      .then(function (res) {
        if (res.ok) {
          // /cart/add.js returns the line item(s) object; items array present when using items:[]
          var item = res.data && res.data.items ? res.data.items[0] : res.data;
          handleSuccess(item, btn);
        } else {
          handleError(btn, res.data && res.data.description);
        }
      })
      .catch(function () { handleError(btn); });
  }

  // ---- (a) PDP form submit ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add$/.test(action)) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.dataset.mvBusy === '1') return;
    postForm(form)
      .then(function (res) {
        if (res.ok) {
          var item = res.data && res.data.items ? res.data.items[0] : res.data;
          handleSuccess(item, btn);
        } else {
          handleError(btn, res.data && res.data.description);
        }
      })
      .catch(function () { handleError(btn); });
  }, false);

  // ---- (b) product-card / element add ----
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-mv-cart-add][data-variant-id]') : null;
    if (!trigger) return;
    e.preventDefault();
    var id = trigger.getAttribute('data-variant-id');
    if (!id) return;
    var qty = trigger.getAttribute('data-quantity') || 1;
    addById(id, qty, trigger);
  }, false);

  // ---- (c) quick-view mini variant picker (product cards) ----
  // A search icon (and, for multi-variant cards, the cart+ button) opens an
  // inline panel with the PDP's swatches + size pills. Selecting options here
  // rewrites the panel add button's data-variant-id / price / availability, so
  // the shared add handler (b) drops the right line item — no full-page load.
  function qvPanelFor(el) {
    var card = el.closest ? el.closest('.mv-card') : null;
    return card ? card.querySelector('[data-mv-qv]') : null;
  }

  function qvVariants(panel) {
    var el = panel.querySelector('[data-mv-qv-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function qvSelectedOptions(panel) {
    var opts = [];
    qsa('[data-mv-qv-option-index]', panel).forEach(function (o) {
      var idx = parseInt(o.getAttribute('data-mv-qv-option-index'), 10);
      var active = o.querySelector('.mv-qv-sw.active, .mv-qv-size.active');
      if (active) opts[idx - 1] = active.getAttribute('data-mv-qv-value');
    });
    return opts;
  }

  function qvMatch(variants, opts) {
    if (!variants.length) return null;
    if (!opts.length) return variants[0];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function qvUpdate(panel) {
    var addBtn = panel.querySelector('[data-mv-qv-add-btn]');
    var addText = panel.querySelector('[data-mv-qv-add-text]');
    var priceEl = panel.querySelector('[data-mv-qv-price]');
    // reflect the chosen value in each option's label
    qsa('[data-mv-qv-option-index]', panel).forEach(function (o) {
      var active = o.querySelector('.mv-qv-sw.active, .mv-qv-size.active');
      var lbl = o.querySelector('[data-mv-qv-optval]');
      if (active && lbl) lbl.textContent = active.getAttribute('data-mv-qv-value');
    });
    if (!addBtn) return;
    // don't clobber the transient "Added"/"Unavailable" flash state
    if (addBtn.dataset.mvBusy === '1') return;
    var v = qvMatch(qvVariants(panel), qvSelectedOptions(panel));
    function label(name, fallback) {
      return addBtn.getAttribute('data-str-' + name) || fallback;
    }
    if (!v) {
      addBtn.disabled = true;
      addBtn.removeAttribute('data-variant-id');
      if (addText) addText.textContent = label('unavailable', 'Unavailable');
      return;
    }
    addBtn.setAttribute('data-variant-id', v.id);
    if (priceEl && v.price) priceEl.textContent = v.price;
    if (v.available) {
      addBtn.disabled = false;
      if (addText) addText.textContent = label('add', 'Add to bag');
    } else {
      addBtn.disabled = true;
      if (addText) addText.textContent = label('soldout', 'Sold out');
    }
  }

  function qvOpen(panel) {
    if (!panel) return;
    // one picker at a time
    qsa('[data-mv-qv].is-open').forEach(function (p) { if (p !== panel) qvClose(p); });
    panel.removeAttribute('hidden');
    qvUpdate(panel);
    // next frame so the slide-up transition runs from the hidden state
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    panel.dataset.mvQvOpen = '1';
  }

  function qvClose(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.dataset.mvQvOpen = '0';
    setTimeout(function () {
      if (!panel.classList.contains('is-open')) panel.setAttribute('hidden', '');
    }, 300);
  }

  // open (search icon / multi-variant cart+)
  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-mv-qv-open]') : null;
    if (!opener) return;
    e.preventDefault();
    e.stopPropagation();
    qvOpen(qvPanelFor(opener));
  }, false);

  // close (× button, or backdrop click outside the inner panel)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-mv-qv-close]')) {
      e.preventDefault();
      qvClose(e.target.closest('[data-mv-qv]'));
      return;
    }
    var panel = e.target.closest('[data-mv-qv].is-open');
    if (panel && !e.target.closest('.mv-qv-inner')) {
      // clicked the dimmed backdrop
      qvClose(panel);
    }
  }, false);

  // option select (swatch / size) inside a panel
  document.addEventListener('click', function (e) {
    var opt = e.target.closest ? e.target.closest('.mv-qv-sw, .mv-qv-size') : null;
    if (!opt) return;
    e.preventDefault();
    e.stopPropagation();
    var group = opt.closest('[data-mv-qv-option-index]');
    if (group) {
      qsa('.mv-qv-sw, .mv-qv-size', group).forEach(function (x) { x.classList.remove('active'); });
    }
    opt.classList.add('active');
    qvUpdate(opt.closest('[data-mv-qv]'));
  }, false);

  // keyboard: activate role="button" options with Enter/Space; Escape closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      qsa('[data-mv-qv].is-open').forEach(qvClose);
      return;
    }
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var opt = e.target && e.target.closest ? e.target.closest('.mv-qv-sw, .mv-qv-size') : null;
    if (!opt) return;
    if (e.key === ' ' || e.key === 'Spacebar') e.preventDefault();
    var group = opt.closest('[data-mv-qv-option-index]');
    if (group) {
      qsa('.mv-qv-sw, .mv-qv-size', group).forEach(function (x) { x.classList.remove('active'); });
    }
    opt.classList.add('active');
    qvUpdate(opt.closest('[data-mv-qv]'));
  }, false);

  // dismiss any open picker once the add succeeds (toast confirms the add)
  document.addEventListener('mv:cart:added', function () {
    qsa('[data-mv-qv].is-open').forEach(qvClose);
  }, false);

  window.MVCart = {
    add: addById,
    refresh: refreshCart,
    hideToast: hideToast
  };

  // Allow closing the toast via a [data-mv-toast-close] control.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-mv-toast-close]')) {
      e.preventDefault();
      hideToast();
    }
  }, false);
})();
